import { BookOpenText } from "lucide-react";

const manifest = {
  key: "platform_guide",
  isFreeModule: true,
  isPurchasable: false,
  icon: BookOpenText,
  names: {
    plan: {
      en: "Platform Guide",
      ar: "\u0627\u0644\u062f\u0644\u064a\u0644 \u0627\u0644\u062a\u0639\u0631\u064a\u0641\u064a \u0644\u0644\u0645\u0646\u0635\u0629",
    },
    dashboard: {
      en: "Platform Guide",
      ar: "\u0627\u0644\u062f\u0644\u064a\u0644 \u0627\u0644\u062a\u0639\u0631\u064a\u0641\u064a \u0644\u0644\u0645\u0646\u0635\u0629",
    },
  },
  defaultPath: "/platform-guide",
  matchers: [/^\/platform-guide(?:\/|$)/],
  buildNavbarMenus: ({ activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "/platform-guide",
    },
  ],
};

export default manifest;
